<script setup>
import {provide, defineProps, onMounted, ref} from 'vue';
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();
import PlaceholderBlock from "@/components/PlaceholderBlock";
import QuizBlock from "@/components/QuizBlock";
import RecipeBlock from "@/components/RecipeBlock";

defineProps({
  initialData: {
    type: Object,
    default: () => ({})
  },
  isRecipe: {
    type: Boolean,
    default: false
  }
});

const menuOpened = ref(false);
const subscriptionAlertVisible = ref(false);

const DLEvent = (eventName, ParameterName1 = 'click', ParameterValue1 = 'click', ParameterName2 = null, ParameterValue2 = null) => {
  const baseEvent = {
    event: 'DLevent',
    eventName: eventName
  };

  let eventData;

  if (ParameterName2 && ParameterValue2) {
    eventData = {
      ParameterName1: ParameterName1,
      ParameterValue1: ParameterValue1,
      ParameterName2: ParameterName2,
      ParameterValue2: ParameterValue2
    };
  } else {
    eventData = {
      ParameterName1: ParameterName1,
      ParameterValue1: ParameterValue1,
    };
  }
  dataLayer.push({ ...baseEvent, ...eventData });
}

provide('DLEvent', DLEvent);

const quizBlock = ref(null);
const returnToFirstStep = () => {
  if (quizBlock.value) {
    quizBlock.value.returnToFirstStep()
  }
}
const onSubscription = () => {
  window.dispatchEvent(new CustomEvent('auth:modal:open', {
    detail: { mode: 'registration' }
  }));
}

const closeSubscriptionAlert = () => {
  subscriptionAlertVisible.value = false;
  sessionStorage.setItem('closeSubscriptionAlert', '1');
}

onMounted(() => {
  setTimeout(() => {
    if (!sessionStorage.getItem('closeSubscriptionAlert')) {
      subscriptionAlertVisible.value = true;
    }
  }, 5000)
})

</script>

<template>
  <div :class="['video-quiz', {'_desktop': width > 1023, '_recipe': isRecipe}, initialData.quiz]" v-if="initialData?.quiz">
    <RecipeBlock :data="initialData" v-if="isRecipe" />
    <QuizBlock :data="initialData" ref="quizBlock" v-else/>
    <template v-if="initialData.quiz === 'w2025'">
      <img :src="require(`@/assets/img/label.svg`)" class="video-quiz__label" v-if="width > 729" @click="returnToFirstStep">
      <img :src="require('@/assets/img/label-mobile.svg')" class="video-quiz__label" v-else @click="returnToFirstStep">
    </template>
    <template v-if="initialData.quiz === 's2026'">
      <img :src="require(`@/assets/img/label-s.png`)" class="video-quiz__label" v-if="width > 729" @click="returnToFirstStep">
      <img :src="require('@/assets/img/label-mobile-s.png')" class="video-quiz__label" v-else @click="returnToFirstStep">
    </template>
    <div :class="['video-quiz__menu', {'video-quiz__menu_opened': menuOpened}]">
      <inline-svg :src="require('@/assets/img/logo.svg')" :class="['video-quiz__logo', {'video-quiz__logo_dark': isRecipe}]"></inline-svg>
      <span class="video-quiz__menu-button" @click="menuOpened = !menuOpened">
        <inline-svg :src="require('@/assets/img/close.svg')" v-show="menuOpened"></inline-svg>
        <inline-svg :src="require('@/assets/img/menu.svg')" v-show="!menuOpened"></inline-svg>
      </span>
      <div class="video-quiz__menu-dropdown" v-if="menuOpened">
        <ul>
          <li>
            <a href="https://t.me/addstickers/FESTIVE_NESCAFE" target="_blank">Получить стикерпак</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <PlaceholderBlock v-else />
  <div :class="['subscription-alert', {'_bordered': !isRecipe}]" v-if="subscriptionAlertVisible">
    <span class="subscription-alert__close" @click="closeSubscriptionAlert">
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25494 6.66962L8.79028 10.205C8.97787 10.3926 9.23231 10.4979 9.49761 10.4979C9.76291 10.4979 10.0173 10.3926 10.2049 10.205C10.3925 10.0174 10.4979 9.76292 10.4979 9.49762C10.4979 9.23232 10.3925 8.97789 10.2049 8.79029L6.66828 5.25496L10.2043 1.71962C10.2971 1.62673 10.3708 1.51647 10.421 1.39512C10.4712 1.27377 10.4971 1.14372 10.497 1.01239C10.497 0.881054 10.4711 0.751013 10.4208 0.629689C10.3705 0.508365 10.2968 0.398134 10.2039 0.30529C10.1111 0.212445 10.0008 0.138805 9.87944 0.088575C9.75809 0.0383447 9.62804 0.0125073 9.49671 0.0125382C9.36537 0.0125692 9.23533 0.0384677 9.11401 0.0887553C8.99269 0.139043 8.88245 0.212735 8.78961 0.305623L5.25494 3.84096L1.71961 0.305623C1.62741 0.21007 1.5171 0.133837 1.39512 0.0813713C1.27314 0.0289056 1.14194 0.00125792 1.00916 4.19358e-05C0.876379 -0.00117405 0.744688 0.0240657 0.621769 0.0742887C0.49885 0.124512 0.387163 0.198712 0.293227 0.29256C0.19929 0.386408 0.124985 0.498025 0.0746457 0.620897C0.0243069 0.743769 -0.00105704 0.875436 3.37445e-05 1.00821C0.00112453 1.14099 0.0286481 1.27223 0.0809988 1.39426C0.133349 1.51628 0.209479 1.62666 0.304944 1.71896L3.84161 5.25496L0.305611 8.79096C0.210146 8.88325 0.134016 8.99363 0.0816657 9.11566C0.029315 9.23769 0.00179115 9.36892 0.000700363 9.5017C-0.000390422 9.63448 0.0249735 9.76614 0.0753123 9.88902C0.125651 10.0119 0.199957 10.1235 0.293893 10.2174C0.38783 10.3112 0.499516 10.3854 0.622436 10.4356C0.745355 10.4858 0.877046 10.5111 1.00982 10.5099C1.1426 10.5087 1.27381 10.481 1.39579 10.4285C1.51777 10.3761 1.62808 10.2998 1.72028 10.2043L5.25494 6.66962Z" fill="white"/>
      </svg>
    </span>
    <h2>Подпишитесь на&nbsp;рассылку</h2>
    <p>Получайте полезные материалы и&nbsp;спецпредложения</p>
    <a href="" @click.prevent="onSubscription">Подписаться</a>
  </div>
</template>
